import clsx from 'clsx'
import {
    useMemo,
    useState,
} from 'react'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {trans} from '../../../../helpers'
import {useUserData} from '../../../../hooks'
import type {UserData} from '../../../../types'
import {SellerReviewsListModal} from '../../../public/seller_info/components/SellerReviewsListModal'
import type {SellerDetailsData} from '../../../public/seller_info/SellerInfoModuleTypes'

interface CabinetUserReviewsButtonProps {
    className?: string
}

// Кнопка отображения отзывов на авторизованного пользователя.
export function CabinetUserReviewsButton(props: CabinetUserReviewsButtonProps) {

    const {
        className,
    } = props

    const user: UserData = useUserData()!

    // Состояние видимости окна с отзывами.
    const [
        isModalVisible,
        setIsModalVisible,
    ] = useState<boolean | null>(null)

    // Конвертация данных пользователя в данные продавца для модального окна.
    const seller: SellerDetailsData = useMemo((): SellerDetailsData => ({
        id: user.id,
        name: user.name ?? '',
        rating: user.rating,
        reviewsCount: user.reviewsCount,
        registrationDate: user.registeredAt ?? '',
    }), [user])

    if (user.reviewsCount === 0) {
        // Нет отзывов: показываем только текст, без возможности нажать.
        return (
            <div>
                {trans().reviews.reviews_count(user.reviewsCount)}
            </div>
        )
    }

    return (
        <>
            <Button
                color="link"
                className={clsx(
                    'link-blue text-nowrap side-nav-link',
                    className
                )}
                onClick={(): void => {
                    setIsModalVisible(true)
                }}
            >
                {trans().reviews.reviews_count(user.reviewsCount)}
            </Button>
            <SellerReviewsListModal
                seller={seller}
                show={isModalVisible}
                onClose={() => {
                    setIsModalVisible(false)
                }}
                onClosed={() => {
                    setIsModalVisible(null)
                }}
            />
        </>
    )
}
